import React from 'react'
import { Bar } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';

const EnvironmentalSocialRisk = ({ socialRiskRatingLegend, dataSafeguards, optionsSafeguards }) => {
    const { t } = useTranslation();

    return (
        <>
            <p className="panel-title-safeguards">{t('extended_report.distribution_environmental_and_social')}</p>
            <p className='panel-subtitle-safeguards'>{t('extended_report.subtitle_distribution_active')}</p>
            <div className="panel-body-safeguards">
                <div className='clasification-distribution'>
                    <div className='content-projects'>
                        <div className='content-project-size'>
                            <p>{t('extended_report.includes_all_sectors')}</p>
                            <p>CSD | IFD | INE | INT | SCL</p>
                        </div>

                        <div>
                            {socialRiskRatingLegend.map(({ label, value, color }) => {
                                return (
                                    <div key={label}>
                                        <div className='content-distribution legend-circle'>
                                            <div className='dot-style' style={{ backgroundColor: color }}></div>
                                            <p>{label}</p>
                                        </div>
                                        <p className='numberOfProyects'>{`${value} ${t('one_pager_report.projects')}`}</p>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    <div className='bar-flex-content'>
                        <p>{t('one_pager_report.projects')}</p>
                        <Bar data={dataSafeguards} options={optionsSafeguards} />
                    </div>
                </div>
            </div>
        </>
    )
}

export default EnvironmentalSocialRisk